import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StateService {
  state: any = {};
  constructor() {}

  setState(newState: any) {
    this.state = newState;
    localStorage.setItem('appState', JSON.stringify(this.state));
  }

  getState(resetIfHasPolicy: boolean = true): any {
    if (resetIfHasPolicy && this.state?.datosPoliza?.polizaId) {
      this.clearState();
    }

    const savedState = localStorage.getItem('appState');
    if (savedState) {
      this.state = JSON.parse(savedState);
    }
    return this.state;
  }

  clearState() {
    this.state = {};
    localStorage.removeItem('appState');
  }
}
